<template>
  <div>
    <loader :loader="sending" />

    <autoLogout />
    <v-dialog v-model="dialogRevalidate" persistent max-width="400">
      <v-card>
        <v-card-title class="text-center"> </v-card-title>
        <v-card-text>
          <h3 class="mt-5">
            ¿Desea cambiar el estado del elemento seleccionado?
          </h3>

          <div class="mt-10">
            <h3 class="ml-10">
              <span class="yellow--text"> Id Estudio : {{ idStudy }}</span>
              <br />
              <span class="yellow--text"> Paciente : {{ patientName }}</span>
              <br /><br />
              <strong class="green--text"> Nuevo estatus : Por validar </strong>
            </h3>
            <br />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogRevalidate = false">
            <v-icon left> mdi-cancel</v-icon> Cancelar
          </v-btn>
          <v-btn color="primary" :disabled="sending" text @click="revalidate()">
            <v-icon left>mdi-content-save-outline</v-icon> Sí, revalidar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" :paramsRoute="paramsRoute" />
      <v-card>
        <v-card-text :class="[list.length < 6 ? 'calendar' : '']">
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
            :single-expand="singleExpand"
            :expanded.sync="list"
            item-key="idStudy"
          >
            <template v-slot:top>
              <div class="row">
                <branch-offices-list
                  :classOfDiv="cols"
                  style="padding-top: 22px"
                  v-on:triggerChange="branchOfficeSelected"
                  :model="idBranchOfficeSelected"
                />
                <div v-if="isViewAdmin()" class="col-sm-12 col-md-2">
                  <div style="padding-top: 9px">
                    <v-autocomplete
                      v-model="modalitiesSelect"
                      :items="modalities"
                      item-text="name"
                      item-value="idModality"
                      auto-select-first
                      clearable
                      label="Modalidad"
                      @change="filterModality()"
                      no-data-text="Sin resultados disponibles"
                    />
                  </div>
                </div>
                <div v-if="isViewAdmin()" class="col-md-2 col-xl-2 col-sm-12">
                  <div style="padding-top: 9px">
                    <v-autocomplete
                      v-model="studyProfileSelect"
                      :items="studyProfileList"
                      item-text="name"
                      item-value="idStudyModality"
                      auto-select-first
                      clearable
                      label="Perfil de estudio"
                      @change="listAll()"
                      no-data-text="Sin resultados disponibles"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-2">
                  <div
                    class="text-right pl-5"
                    id="handCalendar"
                    style="padding-top: 9px"
                  >
                    <vc-date-picker
                      color="green"
                      v-model="date"
                      :max-date="new Date()"
                      is-range
                    >
                      <template v-slot="{ inputEvents }">
                        <div class="flex justify-center items-center">
                          <v-text-field
                            v-on="inputEvents.start"
                            :value="dateCompuded"
                            label="Seleccione fecha"
                            :append-icon="
                              validData ? 'mdi-eraser' : 'mdi-calendar'
                            "
                            @click:append="clearCalendar"
                            :disabled-input="validData"
                          ></v-text-field>
                        </div>
                      </template>
                    </vc-date-picker>
                  </div>
                </div>
                <div class="col">
                  <v-text-field
                    style="padding-top: 22px"
                    v-model="search"
                    label="Buscar"
                    class="pl-1"
                    :append-icon="search ? 'mdi-eraser' : 'mdi-magnify'"
                    @click:append="search = ''"
                  ></v-text-field>
                </div>
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip :color="item.colorStatus" dark small>
                {{ item.status }}
              </v-chip>
            </template>
            <!-- <template v-slot:expanded-item="{ item }">
              <td colspan="1" class="expandedBG"></td>
              <td colspan="2" v-if="speciality == 2" class="expandedBG">
                <b>Accesion Number :</b>
                {{ item.accessionNumber }}
              </td>
              <td colspan="6" v-if="speciality == 2" class="expandedBG">
                <b>Responsable :</b>
                {{ item.responsible }}
              </td>

              <td colspan="2" v-if="speciality == 3" class="expandedBG">
                <b>id Etiqueta :</b>
                {{ item.laboratoryLabel }}
              </td>
              <td colspan="5" v-if="speciality == 3" class="expandedBG">
                <b>Responsable :</b>
                {{ item.responsible }}
              </td>
            </template> -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="checkDetail(item)">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-information-variant
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ver información del Estudio</span>
              </v-tooltip>

              <v-menu
                offset-y
                :nudge-width="200"
                :close-on-content-click="true"
                v-if="
                  speciality == 2
                "
              >
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <span>Más opciones</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    link
                    @click="downloadZIP(item)"
                    v-if="
                      item.statusNumber >= 5 &&
                      $utilFront.withPermission($prm.DOWNLOAD_DICOM)
                       &&
                      item.nameModality !== 'PAPANICOLAOU'
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="blue"> mdi-folder-download </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Descargar DICOM</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="generareteLinkDownload(item)"
                    v-if="
                      item.statusNumber >= 5 &&
                      $utilFront.withPermission($prm.GENERATE_LINK_STUDY)
                      &&
                      item.nameModality !== 'PAPANICOLAOU'
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="gray"> mdi-link </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Link de descarga</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="openColpoModal(item)"
                    v-if="
                      item.nameModality == 'COLPOSCOPIA'
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="cyan"> mdi-file-image </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Adjuntar archivos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="shareByWhatsApp(item)"
                    v-if="
                      item.statusNumber >= 5 &&
                      $utilFront.withPermission($prm.SHARE_WHATSAPP_IMG)
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="success"> mdi-whatsapp </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >Compartir por WhatsApp</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>

                   <!-- NUEVA OPCIÓN "Editar resultados" -->
                  <v-list-item
                    link
                    @click="editPapResults(item)"
                     v-if="item.nameModality === 'PAPANICOLAOU' && $utilFront.withPermission($prm.COORDINATOR_PAP_HISTORY_EDIT)"
                  >
                    <v-list-item-icon>
                      <v-icon color="warning">mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Editar resultados</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="downloadPapReport(item)"
                     v-if="item.nameModality === 'PAPANICOLAOU'"
                  >
                    <v-list-item-icon>
                      <v-icon color="red">mdi-file-pdf-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Papanicolaou</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="papanicolaouViewReport(item)"
                     v-if="item.nameModality === 'PAPANICOLAOU'"
                  >
                    <v-list-item-icon>
                      <v-icon color="red">mdi-file-pdf-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Resultados laboratorio</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <view-image-item
                    v-if="
                      speciality == 2 &&
                      $utilFront.withPermission($prm.VIEWER_WEB_IMG)
                    "
                    :send="() => (sending = !sending)"
                    :sending="sending"
                    :idStudy="item.idStudy"
                  />
                </v-list>
              </v-menu>

              <v-menu
                offset-y
                :nudge-width="200"
                :close-on-content-click="true"
                v-if="
                  speciality == 3 &&
                  ($utilFront.withPermission($prm.LABORATORY_EDIT) ||
                    $utilFront.withPermission($prm.LABORATORY_TAG) ||
                    item.statusNumber == 13 ||
                    item.statusNumber == 7)
                "
              >
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <span>Más opciones</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    link
                    @click="editResults(item)"
                    v-if="$utilFront.withPermission($prm.LABORATORY_EDIT)"
                  >
                    <v-list-item-icon>
                      <v-icon color="warning"> mdi-pencil </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Editar resultados</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="downloadBarcode(item.idStudy)"
                    v-if="$utilFront.withPermission($prm.LABORATORY_TAG)"
                  >
                    <v-list-item-icon>
                      <v-icon> mdi-barcode </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Generar etiqueta</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item link @click="downloadInterpretation(item)">
                    <v-list-item-icon>
                      <v-icon color="error"> mdi-file-pdf-box </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Descargar resultados
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions align="center">
          <v-col>
            <export-import-btn
              texto="Exportar Excel"
              icono="export"
              color="green darken-1"
              @accion="downloadReport(2)"
            />
          </v-col>
          <v-col v-if="speciality == 3">
            <export-import-btn
              texto="Descargar productividad"
              icono="export"
              color="green darken-1"
              @accion="dialogProductivity = true"
            />
          </v-col>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="dialogColpo" persistent max-width="1000">
        <v-card>
          <v-card-title class="text-h6 text-center">
            <span class="success--text"> Adjuntar archivos</span>
          </v-card-title>

          <div class="container">
            <patient-information :model="dataModal" />
            <br />
            <v-subheader
              ><v-icon> mdi-clipboard-text </v-icon>Datos Generales del Estudio
            </v-subheader>
            <v-divider class="mb-5"></v-divider>
            <v-row align="center">
              <v-col>
                <p class="font-weight-black">
                  Modalidad:<br />
                  <span class="font-weight-regular">{{
                    dataModal.nameModality
                  }}</span>
                </p>
              </v-col>
              <v-col>
                <p class="font-weight-black">
                  Estudio:<br />
                  <span class="font-weight-regular">{{
                    dataModal.nameStudy
                  }}</span>
                </p>
              </v-col>
              <v-col>
                <p class="font-weight-black">
                  Id Estudio:<br />
                  <span class="font-weight-regular">{{
                    dataModal.idStudy
                  }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p class="font-weight-black success--text">
                  Accession Number:<br />
                  <span class="font-weight-black">{{
                    dataModal.accessionNumber
                  }}</span>
                </p>
              </v-col>
            </v-row>
            <br />
          </div>
          
          <!-- Texto Motivo / Observacion -->
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-row v-if="existingFiles.length" class="mb-4">
              <v-col cols="12">
                <v-subheader>Archivos existentes</v-subheader>
                <v-list dense>
                  <v-list-item
                    v-for="(f, idx) in existingFiles"
                    :key="f.fileName + idx"
                  >
                    <v-list-item-icon>
                      <v-icon>{{ getIcon(f.fileName) }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ f.fileName }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <div style="display: flex; gap: 8px;">
                        <v-btn small text @click="viewFile(f.url)">
                          Ver
                        </v-btn>
                        <v-btn small text color="red" @click="confirmDelete(idx)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="5">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Adjuntar archivos"
                      :rules="existingFiles.length === 0 ? 'required' : ''"
                      ref="filesProvider"
                    >
                      <v-file-input
                        v-if="dataModal.nameModality === 'COLPOSCOPIA'"
                        multiple
                        v-model="colposcopyFiles"
                        placeholder="Seleccione los archivos"
                        label="Adjuntar archivos"
                        accept=".pdf,application/pdf"
                        show-size
                        counter
                        prepend-icon="mdi-paperclip"
                        :disabled="isReadOnly"
                        :error-messages="errors"
                      />
                      <v-dialog v-model="confirmDeleteDialog" max-width="400">
                        <v-card>
                          <v-card-title class="headline">
                            Confirmar eliminación
                          </v-card-title>
                          <v-card-text>
                            ¿Estás seguro de que deseas eliminar este archivo?
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn text @click="cancelDelete">
                              Cancelar
                            </v-btn>
                            <v-btn color="red" text @click="deleteConfirmed">
                              Eliminar
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </validation-provider>
                  </v-col>
                </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="dialogColpo  = false">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                text
                :loading="sending"
                :disabled="
                  sending ||
                  (dataModal.nameModality === 'COLPOSCOPIA'
                    ? colposcopyFiles.length === 0 && existingFiles.length === 0
                    : invalid)
                "
                @click="handleAcceptModal()"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
            
          </validation-observer>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogProductivity" max-width="600">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Descargar productividad
            <small> Descarga de lista de pacientes atendidos por día </small>
          </v-card-title>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-card-text>
              <v-row align="center" justify="center" class="text-center">
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Fecha"
                    rules="required"
                  >
                    <vc-date-picker
                      color="green"
                      :max-date="new Date()"
                      v-model="dateProductivity"
                      is-required
                      required
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="dialogProductivity = false">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="downloadLaboratoryXLS()"
                :disabled="invalid"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>
      <!-- ETIQUETAS -->
      <v-dialog v-model="dialog3" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center"> Etiqueta </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <h3 class="font-weight-bold">
                    Id Estudio:
                    <span class="error--text">{{ tagModal.idStudy }}</span>
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="font-weight-bold">
                    Paciente:
                    <span class="font-weight-medium">{{
                      tagModal.fullNamePatient
                    }}</span>
                  </h3>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" plain @click="dialog3 = false">
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                :disabled="sending"
                color="primary"
                @click="downloadBarcode(tagModal.idStudy)"
              >
                Generar etiqueta <v-icon right>mdi-barcode</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../components/Sidebar";
import BtnAccion from "../components/btnAccion.vue";
import {
  StudyRequest,
  DownloadZipRequest,
  ReportPDFRequest,
  ModaltyRequest,
  StudyModalityRequest,
} from "@/core/request";
import { mapActions } from "vuex";
import AutoLogout from "../components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { UtilFront } from "@/core";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required, max_value, min_value } from "vee-validate/dist/rules";
import BranchOfficesList from "../components/BranchOfficesList.vue";
import ExportImportBtn from "../components/ExportImportBtn.vue";
import RouteConstants from "@/app/core/RouteConstants";
import ServicePath from "@/core/ServicePath";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";

import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max_value", {
  ...max_value,
  message: "{_field_} no puede exceder de {max}",
});
extend("min_value", {
  ...min_value,
  message: "{_field_} no puede ser menor o igual a 0",
});

export default {
  name: "HistorialEstudio1",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
    ExportImportBtn,
    ViewImageItem,
    PatientInformation,
  },
  computed: {
    dateCompuded() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return "";
      }

      return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
        this.date.end
      ).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return false;
      }
      this.listAll();
      return true;
    },
  },
  data: () => ({
    paramsRoute: {},
    acronym: "TD",
    dialog: false,
    dialog3: false,
    sending: false,
    search: "",
    date: "",
    dataModal: "",
    dialogColpo: false,
    colpoDataModal: null,
    colposcopyFiles: [],
    existingFiles: [],
    tagModal: "",
    speciality: "",
    encabezado: { icono: "mdi-history", texto: "Historial de estudios" },
    quantityRules: [(v) => !!v || "La cantidad de etiquetas es obligatorio"],
    list: [],
    //icono: { icon: "mdi-play", color: "succes s", tooltip: "Comenzar estudio" },
    headers: [
      { text: "Id Estudio", value: "idStudy" },
      { text: "Accession Number", value: "accessionNumber" },
      { text: "Id Paciente", value: "idPatient" },
      { text: "Nombre del paciente", value: "fullNamePatient" },
      { text: "Modalidad", value: "nameModality" },
      { text: "Estudio", value: "nameStudy" },
      { text: "Fecha de inicio", value: "startDate" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    btnPending: {
      route: "/interpretacion/pendientes",
      icon: "mdi-clock-alert-outline",
      text: "Interpretaciones pendientes",
      tooltip: "Ver Interpretaciones pendientes",
    },
    btnProcess: {
      route: "/imagen/comenzar",
      icon: "mdi-play-circle",
      text: "Estudios pendientes",
      tooltip: "Ver estudios pendientes",
    },
    btnDownloadXLSX: {
      icon: "mdi-file-excel",
      text: "Descargar excel",
      tooltip: "Descargar reporte de estudios realizados",
      color: "primary",
    },
    service: StudyRequest,
    valid: false,
    modalities: [],
    studyProfileList: [],
    papMode: "readOnly",
    modalitiesSelect: [],
    studyProfileSelect: null,
    idBranchOfficeSelected: null,
    cols: "col-md-2 col-xl-2 col-sm-12",
    idStudy: null,
    dialogRevalidate: false,
    patientName: "",
    dialogProductivity: false,
    dateProductivity: new Date(),
    branchOfficeProductivity: null,
    expanded: [],
    singleExpand: true,
    confirmDeleteDialog: false,
    fileToDeleteIndex: null,
  }),
  mounted() {
    this.validBrowserTab();
    this.listAllModalities();
    this.listAllStudiesProfile();
    this.listAll();
    console.log("items", this.item )
  },
  created() {
    let speciality1 = localStorage.getItem("speciality");
    this.speciality = this.$route.params.speciality;
    if (this.speciality == undefined || this.speciality == "") {
      this.speciality = speciality1;
      if (this.$utilFront.isEmpty(speciality1)) {
        if (this.$route.path.includes("imagen")) {
          this.speciality = 2;
        } else if (this.$route.path.includes("laboratorio")) {
          this.speciality = 3;
        } else {
          this.speciality = 2;
        }
      }
    } else {
      localStorage.setItem("speciality", this.speciality);
    }
    this.validateData();
  },
  methods: {
    async downloadReport(typeFile) {
      let modalityPost = [];
      if (UtilFront.nonEmpty(this.modalitiesSelect)) {
        modalityPost = [this.modalitiesSelect];
      }
      this.sending = true;
      let fileName = "";
      let postStatus;
      if (this.speciality == 2) {
        fileName = typeFile == 1 ? "Imagen.pdf" : "Imagen.xlsx";
      } else if (this.speciality == 3) {
        fileName = typeFile == 1 ? "Laboratorio.pdf" : "Laboratorio.xlsx";
      }

      let studiePost = null;

      if (UtilFront.nonEmpty(this.studyProfileSelect)) {
        studiePost = this.studyProfileSelect;
      } else {
        studiePost = null;
      }

      postStatus = {
        // status: 1,
        acronym: this.acronym,
        speciality: this.speciality,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        modalities: modalityPost,
        typeFile: typeFile,
        fileName: fileName,
        idStudyModality: studiePost,
      };

      if (this.$utilFront.nonEmpty(this.date)) {
        postStatus.startDate = this.$utilFront.startOfDay(this.date.start);
        postStatus.finishDate = this.$utilFront.endOfDay(this.date.end);
      }

      ReportPDFRequest.exportlaboratory(postStatus)
        .then((res) => {
          if (this.$utilFront.isJSON(res.data.type)) {
            this.$utilFront.displayErrorBlog(res.data);
          } else {
            switch (typeFile) {
              case 1: //PDF
                this.$utilFront.openPDF(res.data);
                break;
              case 2: //XLSX
                this.$utilFront.downloadXLSX(res.data, fileName);
                break;
            }
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    listAllModalities() {
      let post = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : UtilFront.getIdBranchOffice(),
        idSpeciality: this.speciality,
      };

      ModaltyRequest.listModaltyByBranchOfficeAndSpecialty(post).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.modalities = res.data.data.map((modality) => {
            return {
              idModality: modality.idModality,
              name: modality.acronym + " - " + modality.name,
              speciality: modality.speciality || "--- Sin información ---",
              acronym: modality.acronym,
            };
          });
          // this.modalitiesSelect = res.data.data.map((modality) => {
          //   return {
          //     idModality: modality.idModality,
          //   };
          // });
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          this.modalities = [];
        }
      });
    },
    listAllStudiesProfile() {
      if (!this.loader) {
        this.loader = true;
      }

      let idModality = UtilFront.nonEmpty(this.modalitiesSelect)
        ? this.modalitiesSelect
        : null;
      let idSpeciality = this.speciality;
      let idBranchOffice = UtilFront.nonEmpty(this.idBranchOfficeSelected)
        ? this.idBranchOfficeSelected
        : UtilFront.getIdBranchOffice();

      StudyModalityRequest.findAllByModalityAndBranchOfficeAndSpeciality(
        idModality,
        idSpeciality,
        idBranchOffice
      )
        .then((res) => {
          let studyprofile = res.data.data;
          this.studyProfileList = studyprofile;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    listAll() {
      this.sending = true;
      let modalityPost = [];
      let studiePost = null;
      if (UtilFront.nonEmpty(this.modalitiesSelect)) {
        modalityPost = [this.modalitiesSelect];
      }
      if (UtilFront.nonEmpty(this.studyProfileSelect)) {
        studiePost = this.studyProfileSelect;
      } else {
        studiePost = null;
      }

      const { start, end } = this.date || {};
      let postStatus = {
        acronym: this.acronym,
        speciality: this.speciality,
        startDate: start,
        finishDate: end,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        modalities: modalityPost,
        idStudyModality: studiePost,
        status: 0,
      };
      if (postStatus.startDate != null && postStatus.finishDate != null) {
        postStatus.startDate = moment(postStatus.startDate).startOf("day");
        postStatus.finishDate = moment(postStatus.finishDate).endOf("day");
      }

      StudyRequest.listAllByStatus(postStatus)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.list = res.data.data.map((study) => {


              const statusFiltered = this.$cnst.statusNameStudies.find((status) => {
                return status.status === study.status;
              });
              let statusString = "No definido";
              let colorStatus = "";

              if(statusFiltered){
                statusString = statusFiltered.name;
                colorStatus = statusFiltered.color;
                if(statusFiltered.status === 6){
                  statusString = study.statusInterpretation === 2 ? "Por validar" : "Interpretado";
                }
              }
              // if (study.status == 1) {
              //   statusString = "Por Comenzar";
              // } else if (study.status == 2) {
              //   statusString = "Estudio en Proceso";
              // } else if (study.status == 3) {
              //   statusString = "Estudio por Cerrar";
              // } else if (study.status == 4) {
              //   statusString = "Estudio Cancelado o Descartado";
              // } else if (study.status == 5) {
              //   statusString = "Estudio por Interpretar";
              // } else if (study.status == 6) {
             //   statusString = study.statusInterpretation === 2 ? "Por validar" : "Estudio Interpretado";
              // } else if (study.status == 7) {
              //   statusString = "Estudio Entregado";
              // } else if (study.status == 8) {
              //   statusString = "Estudio de Emergencia";
              // } else if (study.status == 13) {
              //   statusString = "Estudio validado";
              // } else if (study.status == 14) {
              //   statusString = "Verificación de imagen";
              // } else if (study.status == 15) {
              //   statusString = "En interpretación";
              // }

              // let colorStatus = "";
              // switch (study.status) {
              //   case 5:
              //     colorStatus = "blue";
              //     break;
              //   case 6:
              //     colorStatus = "green";
              //     break;
              //   case 14:
              //     colorStatus = "orange";
              //     break;
              // }
              let sex;
              if (study.gender === "H") {
                sex = "Masculino";
              } else if (study.gender === "M") {
                sex = "Femenino";
              } else if (study.gender === "X") {
                sex = "No binario";
              }
              return {
                idStudy: study.idStudy,
                colorStatus: colorStatus,
                accessionNumber: UtilFront.nonEmpty(study.accessionNumber)
                  ? study.accessionNumber
                  : "N/D",
                idPatient: study.idPatient,
                fullNamePatient: study.patient || "---",
                nameModality: study.modality || "---",
                nameStudy: study.studyModality || "---",
                registrationDate:
                  moment(new Date(study.registrationDate))
                    .locale("es")
                    .format("DD/MM/YYYY HH:mm") || "---",
                nacPatient:
                  moment(new Date(study.birthDate))
                    .locale("es")
                    .format("DD/MM/YYYY") || "---",
                // sexPatient: study.gender === "H" ? "Masculino" : "Femenino",
                sexPatient: sex,
                idPerson: study.idPerson,
                status: statusString,
                statusNumber: study.status,
                validationDate:
                  this.$utilFront.formatDateTime(study.validationDate) || "---",
                closeDate:
                  moment(new Date(study.closeDate))
                    .locale("es")
                    .format("DD/MM/YYYY HH:mm") || "---",
                startDate:
                  moment(new Date(study.startDate))
                    .locale("es")
                    .format("DD/MM/YYYY HH:mm") || "---",
                startDate:
                  moment(new Date(study.startDate))
                    .locale("es")
                    .format("DD/MM/YYYY HH:mm") || "---",
                laboratoryLabel: UtilFront.nonEmpty(study.laboratoryLabel)
                  ? study.laboratoryLabel
                  : study.accessionNumber,
                responsible: UtilFront.nonEmpty(study.responsible)
                  ? study.responsible
                  : "N/D",
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(res.data.data, "ERROR");
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    checkStudy(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.dialog = true;
    },
    beginStudy(study) {
      let postID = {
        idStudy: study,
      };
      StudyRequest.beginStudy(postID).then((res) => {
        if (res.data.data) {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.$utilFront.notifications(
              "Estudio iniciado correctamente",
              "SUCCESS"
            );
            // this.$router.push("/imagen/estudios");
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Sucedio un error al iniciar el estudio",
              "ERROR"
            );
          }
        }
      });
    },
    checkDetail(item) {
      localStorage.setItem("idStudy", item.idStudy);

      // Si el estudio es de Papanicolaou, revisamos la bandera
      if (item.nameModality === "PAPANICOLAOU") {
        if (this.papMode === "readOnly") {
          this.$router.push({
            name: "InformacionEstudio",
            params: {
              idStudy: item.idStudy,
              idPaciente: item.idPatient,
              idPerson: item.idPerson,
            },
          });
        } else {
          this.$router.push({
            name: "EditarEstudio",
            params: {
              idStudy: item.idStudy,
              idPaciente: item.idPatient,
              idPerson: item.idPerson,
            },
          });
        }
      } else if (this.speciality == 3) {
        this.$router.push({
          name: "ResultadosLaboratorio2",
          params: {
            idStudy: item.idStudy,
            idPaciente: item.idPatient,
            idPerson: item.idPerson,
          },
        });
      } else {
        this.$router.push({
          name: "DetalleEstudio1",
          params: { ...this.paramsRoute },
        });
      }
    },
    validateData() {
      let ls = JSON.parse(localStorage.getItem("modality")) || {};
      let data = ls;
      let nameModality = "";
      this.acronym = "TD";
      if (!(typeof data.acronym === "undefined")) {
        nameModality = data.title;
        this.acronym = data.acronym;
      }
      this.encabezado.texto = "Historial de estudios";
      if (this.speciality == 2) {
        this.btnProcess = {
          route: "/imagen/comenzar",
          icon: "mdi-play-circle",
          text: "Estudios pendientes",
          tooltip: "Ver estudios pendientes",
        };
        this.headers = [
          { text: "", value: "data-table-expand" },
          { text: "Id Estudio", value: "idStudy", align: "center" },
          {
            text: "Accession Number",
            value: "accessionNumber",
            align: "center",
          },
          { text: "Id Paciente", value: "idPatient", align: "center" },
          {
            text: "Nombre del paciente",
            value: "fullNamePatient",
            align: "center",
          },
          { text: "Modalidad", value: "nameModality", align: "center" },
          { text: "Estudio", value: "nameStudy", align: "center" },
          // { text: "Responsable", value: "responsible", align: "center" },
          { text: "Estatus", value: "status", align: "center" },
          {
            text: "Fecha de inicio",
            value: "startDate",
            align: "center",
          },
          {
            text: "Acciones",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      } else if (this.speciality == 3) {
        this.btnProcess = {
          route: "/laboratorio/comenzar",
          icon: "mdi-play-circle",
          text: "Estudios pendientes",
          tooltip: "Ver estudios pendientes",
        };
        this.headers = [
          { text: "", value: "data-table-expand" },
          { text: "Id Estudio", value: "idStudy", align: "center" },
          { text: "Id Etiqueta", value: "laboratoryLabel", align: "center" },

          { text: "Id Paciente", value: "idPatient", align: "center" },
          {
            text: "Nombre del paciente",
            value: "fullNamePatient",
            align: "center",
          },
          { text: "Modalidad", value: "nameModality", align: "center" },
          { text: "Estudio", value: "nameStudy", align: "center" },
          // { text: "Responsable", value: "responsible", align: "center" },
          {
            text: "Fecha de inicio",
            value: "startDate",
            align: "center",
          },
          {
            text: "Acciones",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
   downloadZIP(item) {
  try {
    this.sending = true;
    let data = { idStudy: item.idStudy };
    DownloadZipRequest.downloadImagesDCM(data)
      .then((res) => {
        // Construir el nombre del archivo con el formato: ApellidoNombre - ID.zip
        let filename = '';
        
        if (item.fullNamePatient && item.idPatient) {
          // Separar el nombre completo en partes
          const nameParts = item.fullNamePatient.trim().split(/\s+/);
          
          if (nameParts.length === 1) {
            // Solo un nombre/apellido
            filename = `${nameParts[0]} - ${item.idPatient}.zip`;
          } else if (nameParts.length === 2) {
            // Nombre y apellido: "Nombre Apellido" -> "ApellidoNombre"
            const [nombre, apellido] = nameParts;
            filename = `${apellido}${nombre} - ${item.idPatient}.zip`;
          } else {
            // 3 o más partes: asumimos que el último es apellido paterno y el penúltimo puede ser apellido materno o segundo nombre
            // Para el formato "Apellido(s)Nombre(s)" tomamos los apellidos completos y todos los nombres
            const apellidos = nameParts.slice(-2).join(''); // Últimos 2 elementos como apellidos
            const nombres = nameParts.slice(0, -2).join(''); // El resto como nombres
            filename = `${apellidos}${nombres} - ${item.idPatient}.zip`;
          }
        } else {
          // Fallback al nombre por defecto
          filename = 'Estudio-' + item.idStudy + '.zip';
        }

        console.log('Generated filename:', filename);

        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/zip",
          })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch(this.catchError)
      .finally(() => {
        this.sending = false;
      });
  } catch (e) {
    this.catchError(e);
  }
},
    async generareteLinkDownload(item) {
      try {
        this.sending = true;
        let data = { idStudy: item.idStudy };
        DownloadZipRequest.generateDownloadAccessKey(data)
          .then((response) => {
            if (response.data.code === 200) {
              let accessKey = response.data.data;

              let origin = new URL(location.origin).toString();
              let route = RouteConstants.DOWNLOAD_STUDIES.path;

              route = origin.endsWith("/") ? route.replace("/", "") : route;
              let link = origin + route.replace(":idStudy", accessKey);

              this.$copyText(link)
                .then((e) => {
                  this.$utilFront.notifications(
                    "Link de descarga copiado",
                    "SUCCESS"
                  );
                  this.sending = false;
                })
                .catch(() => {
                  this.sending = false;
                  this.$utilFront.notifications(
                    "error al copiar el link de descarga",
                    "ERROR"
                  );
                });
            } else {
              this.$utilFront.notifications(
                "Ocurrió un error en la generación del link.",
                "ERROR"
              );
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },

    async uploadFiles(files, idStudy) {
      if (!files || files.length === 0) return;
      const formData = new FormData();
      formData.append("jsonData", JSON.stringify({ idStudy, studyFiles: true }));
      for (const f of (Array.isArray(files) ? files : [files])) {
        formData.append("files", f, f.name);
      }
      const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (resp?.status !== 200) {
        this.$utilFront.notifications("Error al adjuntar archivos", "ERROR");
        throw new Error("SaveFiles failed");
      }
    },

    // Handler para el botón “Aceptar” del modal Colpo
    async handleAcceptModal() {
      if (this.dataModal.nameModality !== 'COLPOSCOPIA') {
        
        return;
      }

      this.sending = true;
      try {
       
        const toUpload = [
          ...this.existingFiles.map(f => ({ blob: f.blob, name: f.fileName })),
          ...this.colposcopyFiles.map(f => ({ blob: f, name: f.name }))
        ];

        // FormData para el payload del guardado
        const formData = new FormData();
        formData.append('jsonData', JSON.stringify({
          idStudy: this.dataModal.idStudy,
          studyFiles: true
        }));
        toUpload.forEach(({ blob, name }) => {
          formData.append('files', blob, name);
        });

        // Se envía el payload
        const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (resp.status !== 200) {
          throw new Error('SaveFiles failed');
        }

        this.$utilFront.notifications('Archivos guardados correctamente', 'SUCCESS');
        this.dialogColpo = false;
        await this.listAll();
      } catch (err) {
        console.error(err);
        this.$utilFront.notifications('Error al guardar los archivos', 'ERROR');
      } finally {
        this.sending = false;
      }
    },
    async openColpoModal(item) {
    this.dataModal = { ...item };
    this.colposcopyFiles = [];
    this.existingFiles = [];             
    this.dialogColpo = true;

    try {
      const { data } = await StudyRequest.papanicolaouViewReport({
        idStudy: item.idStudy,
        studyFiles: true
      });
      const files = data.studyFiles || [];
      files.forEach(f => {
        //  base64 a Blob
        const byteChars = atob(f.bytes);
        const byteNumbers = Array.from(byteChars, c => c.charCodeAt(0));
        const blob = new Blob([new Uint8Array(byteNumbers)], { 
          type: 'application/pdf' 
        });
        this.existingFiles.push({
          fileName: f.fileName,
          blob,
          url: URL.createObjectURL(blob)
        });
      });
    } catch (e) {
      console.error("Error al cargar archivos existentes", e);
      this.$utilFront.notifications("No se pudieron cargar los archivos previos", "WARNING");
    }
  },

  getIcon(name) {
    const ext = name.split('.').pop().toLowerCase();
    if (ext === 'pdf') return 'mdi-file-pdf-box';
    if (['jpg','jpeg','png','gif'].includes(ext)) return 'mdi-file-image';
    return 'mdi-file';
  },
  viewFile(url) {
    window.open(url, '_blank');
  },

  
  async confirmColposcopy() {
    this.sending = true;
    try {
      await this.uploadColposcopyFiles();
      this.$utilFront.notifications(
        'Archivos de Colposcopia adjuntados correctamente',
        'SUCCESS'
      );
      this.dialogColpo = false;
      await this.listAll();
    } catch (err) {
      console.error('Error en confirmColposcopy:', err);
    } finally {
      this.sending = false;
    }
  },
  
  async uploadColposcopyFiles() {
    let files = this.colposcopyFiles;
    if (!Array.isArray(files)) files = [files];
    if (files.length === 0) return;
    const formData = new FormData();
    formData.append('jsonData', JSON.stringify({ idStudy: this.colpoDataModal.idStudy }));
    files.forEach(f => formData.append('files', f, f.name));
    const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (resp?.status !== 200) {
      this.$utilFront.notifications(
        'Error al adjuntar archivos de Colposcopia',
        'ERROR'
      );
      throw new Error('SaveFiles failed');
    }
  },

  confirmDelete(idx) {
      this.fileToDeleteIndex = idx;
      this.confirmDeleteDialog = true;
    },
    cancelDelete() {
      this.fileToDeleteIndex = null;
      this.confirmDeleteDialog = false;
    },
    deleteConfirmed() {
      if (this.fileToDeleteIndex !== null) {
        this.removeExistingFile(this.fileToDeleteIndex);
      }
      this.cancelDelete();
    },

    removeExistingFile(idx) {
      this.existingFiles.splice(idx, 1);
    },

    shareByWhatsApp(item) {
      this.sending = true;

      let data = { idStudy: item.idStudy };

      StudyRequest.generateLinkToShareWA(data)
        .then(({ data }) => {
          if (data.code === 200) {
            window.open(
              "https://wa.me/?text=" + encodeURIComponent(data.data),
              "_blank"
            );
          } else {
            this.$utilFront.notifications(
              "El estudio no puede ser compartido, intente más tarde",
              "ERROR"
            );
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },

     editPapResults(item) {

    this.$router.push({
      name: "EditarEstudio",  
      params: {
        idStudy: item.idStudy,
        idPaciente: item.idPatient,
        idPerson: item.idPerson,
      },
    });
  },

  downloadPapReport(item) {
    this.loader = true;
    let data = {
      idStudy: item.idStudy,
      type: 1,
      idBranchOffice: this.$utilFront.getIdBranchOffice()
    };
    StudyRequest.papanicolaouDowloadReport(data);
    this.loader = false;
},
async papanicolaouViewReport(item) {
  this.loader = true;
  try {
    const { data } = await StudyRequest.papanicolaouViewReport({
      idStudy: item.idStudy
    });
    const base64 = data.studyFiles[0].bytes;
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);
    window.open(pdfUrl, '_blank');
  } catch (err) {
    console.error('Error al visualizar el reporte de Papanicolau:', err);
  } finally {
    this.loader = false;
  }
},
    checkSpeciality(item) {
      return item == 2;
    },

    dialogTag(item) {
      this.dialog3 = true;
      this.tagModal = item;
    },

    downloadBarcode(study) {
      this.sending = true;
      try {
        let data = {
          idStudy: study,
          fileName: "Codigo de barras",
          quantityTags: 1,
        };
        ReportPDFRequest.downloadBarcodeLaboratory(data);
      } catch (e) {
        this.catchError(e);
      } finally {
        this.sending = false;
        this.dialog3 = false;
      }
    },
    downloadInterpretation({ idStudy }) {
      this.sending = true;

      let params = {
        idStudy,
        interpretationText: "",
        fileName: "RESULTADOS_LABORATORIO",
      };

      ReportPDFRequest.getReportLaboratoryResults(params)
        .then(({ data }) => {
          this.$utilFront.openPDF(data);
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    downloadLaboratoryXLS() {
      this.sending = true;

      let paramsRequest = {
        status: [13],
        startDate: this.$utilFront.startOfDay(this.dateProductivity),
        finishDate: this.$utilFront.endOfDay(this.dateProductivity),
        idBranchOffice: this.$utilFront.nonEmpty(
          this.idBranchOfficeSelected,
          this.$utilFront.getIdBranchOffice()
        ),
      };
      ReportPDFRequest.downloadLaboratoryXLS(paramsRequest)
        .then((response) => {
          this.$utilFront.downloadXLSX(
            response.data,
            "Reporte de productividad.xlsx"
          );
        })
        .finally(() => {
          this.sending = false;
          this.dialogProductivity = false;
        });
    },
    clearCalendar() {
      this.date = "";
      this.listAll();
    },
    isViewAdmin() {
      return UtilFront.isViewAdmin();
    },
    editResults(item) {
      this.$router.push({
        name: "ResultadosLaboratorio",
        params: {
          edit: true,
          idStudy: item.idStudy,
          readOnly: true,
          idPaciente: item.idPatient,
          idPerson: item.idPerson,
        },
      });
    },
    openDialogRevalidate(idStudy, fullNamePatient) {
      this.idStudy = idStudy;
      this.dialogRevalidate = true;
      this.patientName = fullNamePatient;
    },
    revalidate() {
      if (!this.sending) {
        this.sending = true;
        StudyRequest.revalidate({ idStudy: this.idStudy })
          .then((response) => {
            let { code, status, data } = response.data;
            if (code == 200) {
              this.dialogRevalidate = false;
              this.$utilFront.notifications(
                "Estudio " + this.idStudy + " actualizado.",
                "SUCCESS"
              );
              this.listAll();
            } else {
              this.$utilFront.notifications(
                data || "Ocurrió un error durante el proceso",
                "ERROR"
              );
            }
          })
          .catch(this.$utilFront.errorhttp)
          .finally(() => {
            this.sending = false;
          });
      }
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllModalities();
      this.listAll();
    },
    filterModality() {
      this.studyProfileSelect = null;
      this.listAllStudiesProfile();
      this.listAll();
    },
  },
};
</script>
<style>
.expandedBG {
  background-color: #f4faf2;
}
</style>
